import React, { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { SxProps, Theme } from '@mui/system';

type Props = {
  isLoading: boolean;
  onClick: () => unknown;
  text: string;
  confirmationText: string;
  color?: 'success' | 'error' | 'inherit' | 'primary' | 'secondary' | 'info' | 'warning';
  sx?: SxProps<Theme>;
};

export const ConfirmButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ isLoading, onClick, text, confirmationText, color, sx, ...otherProps }, ref) => {
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleClick = () => {
      if (!showConfirmation) {
        return setShowConfirmation(true);
      }

      onClick();
    };

    return (
      <LoadingButton
        {...otherProps}
        loading={isLoading}
        variant={showConfirmation ? 'contained' : 'outlined'}
        onClick={handleClick}
        data-testid="confirm-button"
        color={color}
        sx={sx}
        ref={ref}
      >
        {showConfirmation ? confirmationText : text}
      </LoadingButton>
    );
  },
);
